import { AuthSupportSummaryModel } from 'src/app/models/auth-support/auth-support-summary-model';
import { AuthSupportSummary } from 'src/swagger-gen/web-secured/models';

export class AuthSupportRepoModelMapper {

    static toAuthSupportSummary(r: AuthSupportSummary): AuthSupportSummaryModel {
        return {
            value: r.value,
            type: r.type,
            uid: r.uid
        };
    }

    static toAuthSupportSummaryList(r: AuthSupportSummary[]): AuthSupportSummaryModel[] {
        return r.map(AuthSupportRepoModelMapper.toAuthSupportSummary);
    }
}
